module.exports = __webpack_public_path__ + "static/media/jhu_horz_resized.e0d0fd04.png";